import { Provider } from '@angular/core';

import { AccountService } from 'src/app/auth/account.service';
import { AuthTokenService } from 'src/app/auth/auth-token.service';
import { DynamicMenuService } from 'src/app/admin/dynamic-menu/dynamic-menu.service';
import { environment } from 'src/environments/environment';

import {
  RiskGradingScoreService,
  RiskGradingService,
  TransactionProfileLimitService,
  TransactionProfileService,
} from 'src/app/admin/assisted-ekyc/configuration/configuration-api.service';

import { applyResetMockQueryParam, MockDb } from './mock-db';
import { MockAccountService } from './services/mock-account.service';
import { MockAuthTokenService } from './services/mock-auth-token.service';
import { MockDynamicMenuService } from './services/mock-dynamic-menu.service';
import {
  MockRiskGradingScoreService,
  MockRiskGradingService,
  MockTransactionProfileLimitService,
  MockTransactionProfileService,
} from './services/mock-configuration.service';
import { EkycRequestService } from 'src/app/admin/assisted-ekyc/shared/ekyc-request.service';
import { MockEkycRequestService } from './services/mock-ekyc-request.service';
import { EkycMetaService } from 'src/app/admin/assisted-ekyc/shared/ekyc-meta.service';
import { MockEkycMetaService } from './services/mock-ekyc-meta.service';
import { ServiceEnrollmentService } from 'src/app/admin/assisted-ekyc/shared/service-enrollment.service';
import { MockServiceEnrollmentService } from './services/mock-service-enrollment.service';
import { AuditLogService } from 'src/app/admin/audit-log/audit-log.service';
import { MockAuditLogService } from './services/mock-audit-log.service';

/**
 * Provider swaps for the showcase build. Specified in contracts-1 §11.1.
 *
 * Module-level providers take precedence over `providedIn: 'root'`, so spreading this array into
 * AppModule is enough to redirect every consumer — no consumer changes anywhere.
 *
 * When `environment.useMock` is false this is an empty array, the real HTTP services are used, and
 * the whole mock layer tree-shakes down to nothing meaningful.
 */
export const mockProviders: Provider[] = environment.useMock
  ? [
      { provide: AuthTokenService, useClass: MockAuthTokenService },
      { provide: AccountService, useClass: MockAccountService },
      { provide: DynamicMenuService, useClass: MockDynamicMenuService },
      { provide: RiskGradingService, useClass: MockRiskGradingService },
      { provide: RiskGradingScoreService, useClass: MockRiskGradingScoreService },
      { provide: TransactionProfileService, useClass: MockTransactionProfileService },
      { provide: TransactionProfileLimitService, useClass: MockTransactionProfileLimitService },
      { provide: EkycRequestService, useClass: MockEkycRequestService },
      { provide: EkycMetaService, useClass: MockEkycMetaService },
      { provide: ServiceEnrollmentService, useClass: MockServiceEnrollmentService },
      { provide: AuditLogService, useClass: MockAuditLogService },
    ]
  : [];

/** Called once at bootstrap. No-op unless the mock layer is active. */
export function initialiseMockLayer(): void {
  if (!environment.useMock) {
    return;
  }
  applyResetMockQueryParam();
  MockDb.ensureSeeded();
}
